import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

const useStyles = makeStyles({
  '.MuiOutlinedInput-adornedEnd': {
    paddingRight: '0',
  },
  root: {
    '& .MuiInputBase-input': {
      fontSize: fonts.sizes.large,
    },
  },
  inputLabel: {
    width: '70%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  adornment: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  paper: {
    marginTop: '4px',
    position: 'absolute',
    backgroundColor: 'white',
    zIndex: 1000,
    width: 'fit-content',
  },
  list: {
    maxHeight: '40vh',
    overflowY: 'auto',
  },
  listItem: {
    padding: '6px 16px',
  },
  listItemNoOptionsText: {
    color: colors.gray,
    padding: '6px 16px',
  },
  iconColor: {
    color: colors.black,
  },
});

export default useStyles;
